export default {
  "products.name": "Name",
  "products.platform": "Platform",
  "products.seller_sku": "Seller SKU",
  "products.shop_sku": "Shop SKU",
  "products.external_product_id": "Platform Product ID",
  "products.platform_model_id": "Platform Model ID",
  "products.platform_sku_id": "Platform SKU ID",
  "products.interface.error": "Error",
  "products.interface.status": "Status",
};
